import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Input, Modal, Spin, Tooltip, message, Popover, Avatar, Card, Switch, Select, InputNumber, Tag } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, EditOutlined, DeleteOutlined, FileImageOutlined } from '@ant-design/icons';

import { IMAGE_CONFIG_LIST, IMAGE_CONFIG_LIST_SUCCESS, IMAGE_CONFIG_LIST_ERROR, DATA_GENERATIONTYPE, DATA_GENERATIONTYPE_SUCCESS, DATA_GENERATIONTYPE_ERROR, MODELTYPE_LIST, MODELTYPE_LIST_SUCCESS, MODELTYPE_LIST_ERROR, MODEL_CLASSIFICATION, MODEL_CLASSIFICATION_SUCCESS, MODEL_CLASSIFICATION_ERROR } from './constants';
import { IMAGE_CONFIG_LIST_DETAILS, IMAGE_CONFIG_LIST_DETAILS_SUCCESS, IMAGE_CONFIG_LIST_DETAILS_ERROR} from './constants';
import { ADD_IMAGE_CONFIG_LIST_DETAILS, ADD_IMAGE_CONFIG_LIST_DETAILS_SUCCESS, ADD_IMAGE_CONFIG_LIST_DETAILS_ERROR } from './constants';
import { UPDATE_IMAGE_CONFIG_LIST_DETAILS, UPDATE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS, UPDATE_IMAGE_CONFIG_LIST_DETAILS_ERROR } from './constants';
import { DELETE_IMAGE_CONFIG_LIST_DETAILS, DELETE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS, DELETE_IMAGE_CONFIG_LIST_DETAILS_ERROR } from './constants';


import imageconfigReducer from './reducer';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import { InfoOutlined} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';


const { Title } = Typography;

export default function ImageClassificationConfiguration() {
	const [form] = Form.useForm();	
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {imgconfig : [] , details: null, pending: false, error: false, datagentype : [], modeltype : [], modelclassification : [] };
	const [data, dispatch] = useReducer(imageconfigReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [ShowAddImageConfigModal, setShowAddImageConfigModal] = useState(false);
	const [ShowEditImageConfigModal, setShowEditImageConfigModal] = useState(false);
	const [showDeleteImageConfigModal, setShowDeleteImageConfigModal] = useState(false);
	const [pidsFilter, setpidsFilter] = useState();
	useAuth();
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const navigate = useNavigate();
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const {getAllEvents,eventsData , pidsData, getPids, channelData, getChannels, wellalgorithmdata, getWellAlgorithm} = useAuth();
	const [reportFilter, setFilter] = useState({pidsinfoId: null, channelId: null, 
		
	}); 
	const handleToggle = (value,record,option)=>{
		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/imageclassificationconfiguration/${record.id}?channelinfoId=${record.channelinfoId}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authtoken}`
			},
			data: {
				[option] : value
				// 'isEnabled' : value
					
			}
		}; 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					Modal.success({ title: `${langdata && langdata.updatedsuccessfully ? langdata.updatedsuccessfully :'Updated Successfully'}` });
					loadImageConfigStatus();
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	
	};

	const loadModeltypes = () => {
		dispatch({ type : MODELTYPE_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/modeltype?$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
			
		axios.request(config)
			.then((response) => {
		
				if (response.status === 200) {
					dispatch({ type : MODELTYPE_LIST_SUCCESS, payload : response.data});
				}else {
					dispatch({ type : MODELTYPE_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : MODELTYPE_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
		
	};

	const loaddatagenerationtype = ()=>{
		dispatch({ type : DATA_GENERATIONTYPE });
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/datagenerationtype/?pipelineId=1&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization':  `Bearer ${authtoken}`
			},
		};
			
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : DATA_GENERATIONTYPE_SUCCESS, payload : response.data});
				} else {
					dispatch({ type : DATA_GENERATIONTYPE_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	const loadModelClassification = ()=>{
		dispatch({ type : MODEL_CLASSIFICATION });
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/modelclassifications/?$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization':  `Bearer ${authtoken}`
			},
		};
			
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : MODEL_CLASSIFICATION_SUCCESS, payload : response.data});
				} else {
					dispatch({ type : MODEL_CLASSIFICATION_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const algoritham = [];
	wellalgorithmdata && wellalgorithmdata.data.map((item) => {		
		algoritham.push({
			value : item.id,
			label : item.name
		});
	});

	
	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: langdata&&langdata.PIDS?langdata.PIDS:'PIDS',
			dataIndex: 'pidsname',
			key: 'pidsname',
			render: (pidsname) => {
				return pidsname.toString().toUpperCase();
			}
		},
		{
			title: langdata&&langdata.channelName?langdata.channelName:'channel Name',
			dataIndex: 'channelname',
			key: 'channelname',
			
		},
		{
			title:langdata&&langdata.ModelName?langdata.ModelName:'Model Name',
			dataIndex: 'alias',
			key: 'alias',
			render : (_,{alias})=>(
				<>
					<Popover content={alias} title={langdata && langdata.Description ? langdata.Description :'Description'} trigger="hover">
						<a onClick={() => navigate('/model-classification-config')}
							style={{ cursor: 'pointer' }}>{alias}</a>
					</Popover>
				</>
			)
			
		},
		{
			title: langdata && langdata.ModelClass ? langdata.ModelClass : 'Model Class',
			dataIndex: 'modelClass',
			key: 'modelClass',
			render: (_, { modelClass }) => {

				if (!modelClass || modelClass.length === 0) {
					return <Tag color="yellow">Nil</Tag>;
				}

				return modelClass.map((item, index) => (
					<Tag
						onClick={() => navigate('/eventtypes')}
						key={index}
						style={{ marginBottom: '5px', cursor: 'pointer' }}
						color="blue"
					>
						{item}
					</Tag>
				));
			},
		},
		{
			title: langdata&&langdata.batchSize?langdata.batchSize:'Batch size',
			dataIndex: 'batchSize',
			key: 'batchSize',
			
		},
		{
			title:langdata&&langdata.targetHeight?langdata.targetHeight:'Target height',
			dataIndex: 'targetHeight',
			key: 'targetHeight',
			
		},
		{
			title:langdata&&langdata.targetWidth?langdata.targetWidth:'Target Width',
			dataIndex: 'targetWidth',
			key: 'targetWidth',
			
		},
		{
			title:langdata&&langdata.Filters?langdata.Filters:'Filters',
			dataIndex: 'wellalgorithmId',
			key: 'wellalgorithmId',
			render: (record) => (
				<Space wrap>
					{record?.length ? 
						record.map(item => {
							const alg = algoritham.find(a => a.value === item);
							return (
								<Tag color={'blue'} key={item} style={{ cursor: 'pointer' }}
									onClick={() => navigate('/filter-type')}>
									{alg?.label}
								</Tag>
							);
						}) : 
						<Tag color={ 'yellow'}>
							{'Nil'}
						</Tag>
					}
				</Space>	
			)
					
		},
		{
			title:langdata&&langdata.eventTypes?langdata.eventTypes:'Event Types',
			dataIndex: 'eventTypes',
			key: 'eventTypes',
			render: (_,{ eventTypes}) => (
				eventTypes.map((item, index)=>(
					<Tag  onClick={()=>navigate('/eventtypes')}  key={index}  style={{marginBottom : '5px', cursor : 'pointer'}} color={'blue'} >
						{item}
					</Tag>
				))
	
			),
			
		},
		{
			title:langdata&&langdata.DataGeneration?langdata.DataGeneration:'Data Generation',
			dataIndex: 'datagenerationName',
			key: 'datagenerationName',
			render: (_, { datagenerationName  }) => (
				<>
					<Tag color={'green'} >
						{datagenerationName}
					</Tag>
				</>
			),
		},
		{
			title:langdata&&langdata.ModelType?langdata.ModelType:'Model Type',
			dataIndex: 'modeltypeName',
			key: 'modeltypeName',
			
		},
		{
			title:langdata&&langdata.ConfidenceThreshold?langdata.ConfidenceThreshold:'Confidence Threshold',
			dataIndex: 'confidenceThreshold',
			key: 'confidenceThreshold',
			
		},
		{
			title:langdata&&langdata.modelPath?langdata.modelPath:'Model Path',
			key: 'modelPath',
			dataIndex: 'modelPath',
			render: (_, record) => {
				return (
					<Popover
						content={record?.curlEnabled ? record?.curlPath : record?.modelPath}
						title={record?.curlEnabled  ? 'Curl Path' : 'Model Path'}
						trigger="hover"
					>
						<Typography.Text ellipsis style={{ maxWidth: 100, cursor: 'pointer' }}>
							{record?.curlEnabled ? record?.curlPath ? record.curlPath : '-' : record?.modelPath ? record.modelPath : '-'}
						</Typography.Text>
					</Popover>
				);
			}
		},
		// {
		// 	title:langdata&&langdata.curlPath?langdata.curlPath:'Curl Path',
		// 	dataIndex: 'curlPath',
		// 	key: 'curlPath',
			
		// },
		{
			title:langdata&&langdata.PickleFilePath?langdata.PickleFilePath:'Pickle File Path',
			dataIndex: 'pickleFilePath',
			key: 'pickleFilePath',
			render: (_, record) => {
				return (
					<Popover
						content={record?.pickleFilePath}
						title={langdata&&langdata.PickleFilePath?langdata.PickleFilePath:'Pickle File Path'}
						trigger="hover"
					>
						<Typography.Text ellipsis style={{ maxWidth: 100, cursor: 'pointer' }}>
							{record?.pickleFilePath}
						</Typography.Text>
					</Popover>
				);
			}
		},
		
		{
			title:langdata&&langdata.eventConfidenceThreshold?langdata.eventConfidenceThreshold:'Event Confidence Threshold',
			dataIndex: 'eventConfidenceThreshold',
			key: 'eventConfidenceThreshold',
			
		},
		
		{
			title:langdata&&langdata.eventWidthThreshold?langdata.eventWidthThreshold:'Event Width Threshold',
			dataIndex: 'eventWidthThreshold',
			key: 'eventWidthThreshold',
			
		},
		{
			title:langdata&&langdata.timeTolerance?langdata.timeTolerance:'Time Tolerance',
			dataIndex: 'timeTolerance',
			key: 'timeTolerance',
			
		},
		{
			title:langdata&&langdata.durationThreshold?langdata.durationThreshold:'Duration Threshold',
			dataIndex: 'durationThreshold',
			key: 'durationThreshold',
			
		},
		{
			title:langdata&&langdata.eventPositionTolerance?langdata.eventPositionTolerance:'Event Position Tolerance',
			dataIndex: 'eventPositionTolerance',
			key: 'eventPositionTolerance',
			
		},
		
		
		
		{
			title:langdata&&langdata.CurlEnabled?langdata.CurlEnabled:'Curl Enabled',
			dataIndex: 'curlEnabled',
			key: 'curlEnabled',
			width : 100,
		
			render: (toggle, record) => (
				<>
					<Switch size='small'  value={toggle} onChange={(value) => handleToggle(value,record,'curlEnabled')} />
				</>
			),
			
		},
		{
			title: `${langdata&&langdata.Status?langdata.Status:'Status'}`,
			dataIndex: 'isEnabled',
			key: 'isEnabled',
			width : 100,
		
			render: (toggle, record) => (
				<>
					<Switch size='small'  value={toggle} onChange={(value) => handleToggle(value,record,'isEnabled')} />
				</>
			),
		},
	];

	if(permission === 'superadmin' || permission === 'admin' ){
		columns.push({
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				
				<Space size="middle">
					<a title={langdata&&langdata.EditImageConfig?langdata.EditImageConfig:'Edit Image Configuration'} onClick={()=>{openEditImageConfigModal(record);}}><EditOutlined/></a>
					<a title={langdata&&langdata.DeleteImageConfig?langdata.DeleteImageConfig:'Delete Image Configuration'} onClick={openDeleteImageConfigModal}><DeleteOutlined /></a>
				</Space>
				
			)
		});
	}

	const openAddVehicleStatusModal = () => {
		setShowAddImageConfigModal(true);
	};

	const cloaseImageConfigModal = () => {
		setShowAddImageConfigModal(false);
		form.resetFields();
		addImageconfigFormik.resetForm();
		setFilter({...reportFilter,pidsinfoId:null});
	};

	const openEditImageConfigModal = (record) => {
		getChannels(authtoken,record.pidsinfoId);
		setShowEditImageConfigModal(true);
	};

	const closeEditImageConfigModal = () => {
		setShowEditImageConfigModal(false);
		updateImageConfigFormik.resetForm();
		form.resetFields(); 	 	 
	};

	const openDeleteImageConfigModal = () => {
		setShowDeleteImageConfigModal(true);
	};

	const deleteImageConfigStatus = () => {
		const id = parseInt(data.details.id);
    
		dispatch({ type: DELETE_IMAGE_CONFIG_LIST_DETAILS });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/imageclassificationconfiguration/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS, payload: response});
					setShowDeleteImageConfigModal(false);   
					loadImageConfigStatus();       
				} else {
					dispatch({type:DELETE_IMAGE_CONFIG_LIST_DETAILS_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_IMAGE_CONFIG_LIST_DETAILS_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	};


	const closeDeleteImageConfigModal = () => {
		setShowDeleteImageConfigModal(false);
	};

	useEffect(() => {
		if(featuresModule.imageclassificationManagementEnabled == false) {
			navigate('/dashboard');
		}
		
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4023);
	}, []);

	useEffect(() => {
		dispatch( { type: IMAGE_CONFIG_LIST });
      
		loadImageConfigStatus();
		getPids(authtoken);
		getWellAlgorithm(authtoken);
		loaddatagenerationtype();
		loadModeltypes();
		loadModelClassification();

	}, [authtoken,pidsFilter]);


	useEffect(() => {
		getAllEvents(authtoken);
		
	}, [authtoken]);


	const loadImageConfigStatus = () => {
		let pidsort = '';

		if(pidsFilter){
			pidsort = `&pidsinfoId=${pidsFilter}`;
		}

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/imageclassificationconfiguration?pipelineId=${parseInt(pipelineId)}&$sort[id]=-1${pidsort}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:IMAGE_CONFIG_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:IMAGE_CONFIG_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	};

	const loadImageConfigDetails = ((record) => {


		dispatch( { type: IMAGE_CONFIG_LIST_DETAILS });
    
		if (!record) {
			dispatch({ type: IMAGE_CONFIG_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: IMAGE_CONFIG_LIST_DETAILS_SUCCESS, payload: record });

		}

	});

	const datagenop = [{value : null, label : 'Nil'}];
	data?.datagentype && data?.datagentype.map((item) => {		
		datagenop.push({
			value : item.id,
			label : item.name
		});
	});

	const modelclassificationop = [];
	data?.modelclassification && data?.modelclassification.map((item) => {		
		modelclassificationop.push({
			value : item.id,
			label : item.alias
		});
	});
	



	const addImageconfigFormik = useFormik({
		initialValues: {
			name : '',
			channelinfoId : null,
			batchSize : 0,
			targetHeight : 0,
			targetWidth : 0,
			eventTypes : null,
			modelPath : '',
			timeTolerance : 0,
			eventPositionTolerance : 0,
			eventConfidenceThreshold : 0,
			eventWidthThreshold : 0,
			durationThreshold : 0,
			confidenceThreshold : 0,
			pidsinfoId : null,
			curlPath : '',
			pickleFilePath : '',
			wellalgorithmId : null,
			modeltypeId : null,
			datagenerationtypeId : null,
			modelclassificationId : null,
		},
		onSubmit: (values) => {
			const name = values.name ? values.name : '';
			const pidsinfoId =  values.pidsinfoId ? values.pidsinfoId : null;
			const channelinfoId = values.channelinfoId ? values.channelinfoId : 0;
			const batchSize = values.batchSize ? values.batchSize : 0;
			const targetHeight = values.targetHeight ? values.targetHeight : 0;
			const targetWidth = values.targetWidth ? values.targetWidth : 0;
			const eventTypes = values.eventTypes ? values.eventTypes : [];
			const modelPath = values.modelPath ? values.modelPath : '';
			const timeTolerance = values.timeTolerance ? values.timeTolerance : 0;
			const eventPositionTolerance = values.eventPositionTolerance ? values.eventPositionTolerance : 0;
			const eventConfidenceThreshold = values.eventConfidenceThreshold ? values.eventConfidenceThreshold : 0;
			const eventWidthThreshold = values.eventWidthThreshold ? values.eventWidthThreshold : 0;
			const durationThreshold = values.durationThreshold ? values.durationThreshold : 0;
			const confidenceThreshold = values.confidenceThreshold ? values.confidenceThreshold : 0;
			const curlPath = values.curlPath ? values.curlPath  : '';
			const pickleFilePath = values.pickleFilePath ? values.pickleFilePath : '';
			const wellalgorithmId = values.wellalgorithmId ? values.wellalgorithmId : [];
			const modeltypeId = values.modeltypeId ? values.modeltypeId : null;
			const datagenerationtypeId = values.datagenerationtypeId ? values.datagenerationtypeId : null;
			const modelclassificationId = values.modelclassificationId ? values.modelclassificationId : null;

			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}
			if (!pidsinfoId || pidsinfoId == null || pidsinfoId === 0) {
				Modal.warning({ title: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS' });
				return false;
			}

			if (!channelinfoId || channelinfoId == null || channelinfoId === 0) {
				Modal.warning({ title: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'});
				return false;
			}

			if (!batchSize || batchSize == null || batchSize === 0) {
				Modal.warning({ title:langdata&&langdata.PleaseEnterBatchSize?langdata.PleaseEnterBatchSize:'Please Enter Batch size' });
				return false;
			}
			if (!targetHeight || targetHeight == null || targetHeight === 0) {
				Modal.warning({ title: langdata&&langdata.PleaseEnterTargetHeight?langdata.PleaseEnterTargetHeight:'Please Enter Target Height'});
				return false;
			}
			if (!targetWidth || targetWidth == null || targetWidth === 0) {
				Modal.warning({ title: langdata&&langdata.PleaseEnterTargetWidth?langdata.PleaseEnterTargetWidth:'Please Enter the Target Width' });
				return false;
			}

			if (!modelPath || modelPath == null || modelPath === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter Model Path'});
				return false;
			}
			if (!timeTolerance || timeTolerance == null || timeTolerance === 0) {
				Modal.warning({ title: langdata&&langdata.PleaseEnterTimeTolerance?langdata.PleaseEnterTimeTolerance:'Please the  enter Time Tolerance'});
				return false;
			}
			if (!eventPositionTolerance || eventPositionTolerance == null || eventPositionTolerance === 0) {
				Modal.warning({ title: langdata&&langdata.PleaseEnterEventPositionTolerance?langdata.PleaseEnterEventPositionTolerance:'Please Enter  the event Position Tolerance' });
				return false;
			}
			if (!eventConfidenceThreshold || eventConfidenceThreshold == null || eventConfidenceThreshold === 0) {
				Modal.warning({ title: langdata&&langdata.PleaseEnterEventConfidenceThreshold?langdata.PleaseEnterEventConfidenceThreshold:'Please enter the  event confidence threshold'});
				return false;
			}
			if (!eventWidthThreshold || eventWidthThreshold == null || eventWidthThreshold === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterEventWidthThreshold?langdata.PleaseEnterEventWidthThreshold:'Please Enter Event Width Threshold' });
				return false;
			}
			
			if (!durationThreshold || durationThreshold == null || durationThreshold === 0) {
				Modal.warning({ title: langdata&&langdata.PleaseEnterDurationThreshold?langdata.PleaseEnterDurationThreshold:'Please enter  the duration Threshold'});
				return false;
			}
			if (!confidenceThreshold || confidenceThreshold == null || confidenceThreshold === 0) {
				Modal.warning({ title: langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please enter  the confidence Threshold'});
				return false;
			}
			if (!modelclassificationId || modelclassificationId == null || modelclassificationId === 0) {
				Modal.warning({ title: langdata&&langdata.PleaseSelectModelClass?langdata.PleaseSelectModelClass:'Please select model class'});
				return false;
			}
			// if (!modeltypeId || modeltypeId == null || modeltypeId === 0) {
			// 	Modal.warning({ title: langdata&&langdata.Pleaseslectm?langdata.PleaseSelectDataGenerationType:'Please select data generation type'});
			// 	return false;
			// }
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/imageclassificationconfiguration`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					channelinfoId : channelinfoId ,
					batchSize : Number(batchSize),
					targetHeight : Number(targetHeight) ,
					targetWidth : Number(targetWidth) ,
					eventTypes : eventTypes ,
					modelPath : modelPath,
					timeTolerance : Number(timeTolerance),
					eventPositionTolerance : parseInt(eventPositionTolerance),
					eventConfidenceThreshold : Number(eventConfidenceThreshold),
					eventWidthThreshold : Number(eventWidthThreshold),
					durationThreshold : Number(durationThreshold),
					pipelineId : parseInt( pipelineId ),
					pidsinfoId : pidsinfoId,
					curlPath : curlPath,
					pickleFilePath : pickleFilePath,
					wellalgorithmId : wellalgorithmId,
					confidenceThreshold : parseFloat(confidenceThreshold),
					datagenerationtypeId : datagenerationtypeId,
					modeltypeId : modeltypeId,
					modelclassificationId : modelclassificationId,
				}
			};

			dispatch( { type: ADD_IMAGE_CONFIG_LIST_DETAILS });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_IMAGE_CONFIG_LIST_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.EventvalidatorAddedSuccessfully ? langdata.EventvalidatorAddedSuccessfully : 'Event validator added successfully' });
						setShowAddImageConfigModal(false);
						addImageconfigFormik.resetForm();
						form.resetFields();
						loadImageConfigStatus();
					} else {
						dispatch({type: ADD_IMAGE_CONFIG_LIST_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToAddEventValidator ? langdata.UnableToAddEventValidator : 'Unable To Add Event Validator' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_IMAGE_CONFIG_LIST_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}else{
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
						});
					}
				});
		}
	});

	const updateImageConfigFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name : data.details ? data.details.name : '',
			channelinfoId :  data.details ? data.details.channelinfoId : 0,
			batchSize :  data.details ? data.details.batchSize : 0,
			targetHeight : data.details ? data.details.targetHeight : 0,
			targetWidth : data.details ? data.details.targetWidth : 0,
			eventTypes : data.details ? data.details.eventTypes : null,
			modelPath : data.details ? data.details.modelPath : 0,
			timeTolerance : data.details ? data.details.timeTolerance : 0,
			eventPositionTolerance : data.details ? data.details.eventPositionTolerance : 0,
			eventConfidenceThreshold : data.details ? data.details.eventConfidenceThreshold : 0,
			eventWidthThreshold : data.details ? data.details.eventWidthThreshold : 0,
			durationThreshold : data.details ? data.details.durationThreshold : 0,
			pidsinfoId : data.details ? data.details.pidsinfoId : null,
			curlPath : data.details ? data.details.curlPath : '',
			pickleFilePath : data.details ? data.details.pickleFilePath : '',
			wellalgorithmId :  data.details ? data.details.wellalgorithmId : [],
			datagenerationtypeId : data.details ? data?.details.datagenerationtypeId : null,
			modelclassificationId : data.details ? data?.details.modelclassificationId : null,
			modeltypeId : data.details ? data?.details.modeltypeId : null,
			confidenceThreshold : data.details ? data?.details.confidenceThreshold : null,
		

		},
		onSubmit: (values) => {
			const id = data?.details?.id;
			const name = values.name ? values.name : '';
			const channelinfoId = values.channelinfoId ? values.channelinfoId : null;
			const batchSize = values.batchSize ? values.batchSize : 0;
			const targetHeight = values.targetHeight ? values.targetHeight : 0;
			const targetWidth = values.targetWidth ? values.targetWidth : 0;
			const eventTypes = values.eventTypes ? values.eventTypes : null;
			const modelPath = values.modelPath ? values.modelPath : '';
			const timeTolerance = values.timeTolerance ? values.timeTolerance : 0;
			const eventPositionTolerance = values.eventPositionTolerance ? values.eventPositionTolerance : 0;
			const eventConfidenceThreshold = values.eventConfidenceThreshold ? values.eventConfidenceThreshold : 0;
			const eventWidthThreshold = values.eventWidthThreshold ? values.eventWidthThreshold : 0;
			const durationThreshold = values.durationThreshold ? values.durationThreshold : 0;
			const pidsinfoId = values.pidsinfoId ? values.pidsinfoId : null;
			const curlPath = values.curlPath ? values.curlPath : '';
			const pickleFilePath = values.pickleFilePath ? values.pickleFilePath : '';
			const wellalgorithmId = values.wellalgorithmId ? values.wellalgorithmId : [];
			const datagenerationtypeId = values.datagenerationtypeId ? values.datagenerationtypeId : null;
			const modelclassificationId = values.modelclassificationId ? values.modelclassificationId : null;
			const modeltypeId = values.modeltypeId ? values.modeltypeId : null;
			const confidenceThreshold = values.confidenceThreshold ? values.confidenceThreshold : null;

			if(!channelinfoId || channelinfoId == null || channelinfoId === 0) {
				Modal.warning({ title: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'});
				return false;
			}
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/imageclassificationconfiguration/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					channelinfoId : channelinfoId ,
					batchSize : Number(batchSize),
					targetHeight : Number(targetHeight) ,
					targetWidth : Number(targetWidth) ,
					eventTypes : eventTypes ,
					modelPath : modelPath,
					timeTolerance : Number(timeTolerance),
					eventPositionTolerance : parseInt(eventPositionTolerance),
					eventConfidenceThreshold : Number(eventConfidenceThreshold),
					eventWidthThreshold : Number(eventWidthThreshold),
					durationThreshold : Number(durationThreshold),
					pipelineId : parseInt( pipelineId ),
					pidsinfoId : pidsinfoId,
					curlPath : curlPath,
					pickleFilePath : pickleFilePath,
					wellalgorithmId : wellalgorithmId,
					datagenerationtypeId : Number(datagenerationtypeId),
					modelclassificationId : modelclassificationId,
					modeltypeId : modeltypeId,
					confidenceThreshold : Number(confidenceThreshold)

				}
			};

			dispatch( { type: UPDATE_IMAGE_CONFIG_LIST_DETAILS });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: UPDATE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS, payload:response});
						Modal.success({ title: langdata && langdata.EventvalidatorUpdatedSuccessfully ? langdata.EventvalidatorUpdatedSuccessfully : 'Event validator Updated Successfully.' });
						setShowEditImageConfigModal(false);
						form.resetFields();
						updateImageConfigFormik.resetForm();
						loadImageConfigStatus();
					} else {
						dispatch({type: UPDATE_IMAGE_CONFIG_LIST_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToUpdateEventvalidator ? langdata.UnableToUpdateEventvalidator : 'Unable to update event validator' });  
					}
				})
				.catch((error) => {
					dispatch({type: UPDATE_IMAGE_CONFIG_LIST_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}else{
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
						});
					}
				});
		}
	});
	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.EventvalidatorInfoContent ? langdata.EventvalidatorInfoContent  :  'This module provides configuration for larger-window models that validate events predicted by primary models. It includes filters for chains to control how data is filtered and prepared before being used by the validation model. All chain-level filtering and final data generation for the model can be managed through this module.'}</p>
		</Card>
	);

	let pids=[];
	let pidsfilter=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];

	pidsData && pidsData.map((pid)=>{
		pids.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});
	
	pidsData && pidsData.map((pid)=>{
		pidsfilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});
	let allevents=[];
    
	eventsData && eventsData.map((item) => {
		allevents.push({
			value : item.eventType,
			label: item.eventType
		});
	});
	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	let channels=[];

	channelData && channelData.map((item) => {
		channels.push({
			value : item.id,
			label : item.name,
		});
	});
	


	pids.sort((a, b) => { return a.value - b.value; });

	const handleAddFormValuesChange = (changedValues)=>{
		
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key];
		if(key ==='PIDS'){
			getChannels(authtoken,val);
			setFilter({...reportFilter,pidsinfoId:val, channelId : 'all'});
			addImageconfigFormik.setFieldValue('pidsinfoId', val);
			addImageconfigFormik.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
		}

		if(key==='channelinfoId'){
			setFilter({...reportFilter,channelId:val});
			addImageconfigFormik.setFieldValue('channelinfoId', val);
		}
	};
			
	const handleupdateFormValuesChange = (changedValues)=>{
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key];
		if(key ==='PIDS'){
			// getChannels(authtoken,val);
			setFilter({...reportFilter,pidsinfoId:val, channelId : 'all'});
			updateImageConfigFormik.setFieldValue('pidsinfoId', val);
			updateImageConfigFormik.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
		}

		if(key==='channelinfoId'){
			setFilter({...reportFilter,channelId:val});
			updateImageConfigFormik.setFieldValue('channelinfoId', val);
		}
	};

	const handlepidsfilter = (value) =>{
		setpidsFilter(value);
	};	

	const modeltypeop = [];
	data?.modeltype && data?.modeltype.map((item) => {		
		modeltypeop.push({
			value : item.id,
			label : item.name
		});
	});	

	

	return (
		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
						
				}}
				>
					<Col span={12}>
						<Row>
							<Space>
								<FileImageOutlined style={{fontSize:'30px'}}/>
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata&&langdata.EventValidator ? langdata.EventValidator:'EventValidator' }</Title>
						</Row>
					</Col>
					
					<Col span={12}>
						<Row justify="end">
							<Col>
								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.Filterbypids ? langdata.Filterbypids :'Filter by pids'}>
														
										<Space>
											<Select Item
												style={{ minWidth: '200px', margin:'5px'}}
												showSearch
												filterOption={filterOption}
												placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
												optionFilterProp="children"
												// onChange={onChange}
												// onSearch={onSearch}
												// filterOption={filterOption}
												defaultValue={null}
												options={pidsfilter}
												onSelect={handlepidsfilter}
												
														
											/>  
										</Space>
									</Tooltip>  
								</Space>
								<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
									<Space>
										{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={openAddVehicleStatusModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
									</Space>
								</Tooltip>
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata&&langdata.EventValidator?langdata.EventValidator:'EventValidator' }  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ data && data.imgconfig.length > 0 ? (
							<Table
								scroll={{
									x: 900,
								}} 
								columns={columns} 
								dataSource={data && data.imgconfig} 
								onRow = {(record) => {
									return {
										onClick: () => { 
											loadImageConfigDetails(record);
										}
									};
								}} />
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>
			</Content>

			<Spin fullscreen spinning={data.pending} />
      
			{/*  Add Image config Starts */}
			<Modal
				title={ langdata&&langdata.AddEventValidator?langdata.AddEventValidator:'Add Event Validator' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={ShowAddImageConfigModal}
				onOk={{cloaseImageConfigModal}}
				onCancel={cloaseImageConfigModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={cloaseImageConfigModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addImageconfigFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical"  onSubmit={addImageconfigFormik.handleSubmit} form={form} onValuesChange={handleAddFormValuesChange}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} required>
								<Input name="name" onChange={addImageconfigFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ required: true, message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
								<Select Item
									name="PIDS"
									style={{ width: '100%'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
									optionFilterProp="children"
									// value={reportFilter.pidsinfoId}
									value={reportFilter.pidsinfoId}
									onSelect={(value)=>{handleAddFormValuesChange({'PIDS': value});}}             
									options={pids}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="channelinfoId" label={ langdata&&langdata.channelName?langdata.channelName:'channel Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'PleaseEnterChannelName'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="channelinfoId"
									showSearch
									filterOption={filterOption}
									disabled={reportFilter.pidsinfoId ? false :true}
									placeholder={langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}
									optionFilterProp="children"	
									onSelect={(value)=>{handleAddFormValuesChange({'channelinfoId': value});}}
									value={addImageconfigFormik.values.channelinfoId}
									// onSelect={handleSetChannel}
									options={channels}
									
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="batchSize" label={langdata&&langdata.batchSize?langdata.batchSize:'Batch Size'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterBatchSize?langdata.PleaseEnterBatchSize:'Please Enter Batch size'}]} >
								<InputNumber 
									name="batchSize" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('batchSize', value)} 
									placeholder={langdata&&langdata.PleaseEnterBatchSize?langdata.PleaseEnterBatchSize:'Please Enter Batch size'} />
							</Form.Item>
						</Col>
					</Row>
					
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.eventTypes ? langdata.eventTypes : 'Event Types'} name="eventTypes" rules={[{ required: false, message : langdata && langdata.PleaseEnterEventTypes ? langdata.PleaseEnterEventTypes : 'Please select the  Event Types' }]}>
								<Select Item
									name="eventTypes"
									mode="multiple"
									showSearch
									placeholder={langdata && langdata.PleaseEnterEventTypes ? langdata.PleaseEnterEventTypes : 'Please select the  Event Types'}
									optionFilterProp="children"
									filterOption={filterOption}
									options={allevents}
									onChange={(value) => addImageconfigFormik.setFieldValue('eventTypes', value)}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name='eventTag' >
								<Tag name='eventTag' style={{
									maxWidth: '100%',
									whiteSpace: 'normal',
									wordBreak: 'break-word',
									lineHeight: '1.9'
								}} color="blue">{langdata && langdata.PredictionEventType ? langdata.PredictionEventType : 'Predict Event Type' } {'['}{addImageconfigFormik.values && addImageconfigFormik.values.eventTypes && addImageconfigFormik.values.eventTypes.toString()}{']'} </Tag>
							</Form.Item>
						</Col>
						<Space>&nbsp;</Space>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.modelPath ? langdata.modelPath : 'Model Path'} rules={[{ required: true, message: langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter model Path' }]} required>
								<Input 
									name="modelPath" 
									onChange={addImageconfigFormik.handleChange} 
									placeholder={langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter model Path'} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.curlPath ? langdata.curlPath : 'Curl Path'} rules={[{ required: false, message: langdata && langdata.PleaseEnterCurlPath ? langdata.PleaseEnterCurlPath : 'Please the enter Curl Path' }]} >
								<Input 
									name="curlPath" 
									onChange={addImageconfigFormik.handleChange} 
									placeholder={langdata && langdata.PleaseEnterCurlPath ? langdata.PleaseEnterCurlPath : 'Please the enter curl Path'} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.PickleFilePath ? langdata.PickleFilePath : 'Pickle File Path'} rules={[{ required: false, message: langdata && langdata.PleaseEnterPickleFilePath ? langdata.PleaseEnterPickleFilePath : 'Please Enter Pickle File Path' }]} >
								<Input 
									name="pickleFilePath" 
									onChange={addImageconfigFormik.handleChange} 
									placeholder={langdata && langdata.PleaseEnterPickleFilePath ? langdata.PleaseEnterPickleFilePath : 'Please Enter Pickle File Path'} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Filters ? langdata.Filters : 'Filters'} name="wellalgorithmId" rules={[{ required: false , message : langdata && langdata.PleaseSelectWellAlgorithm ? langdata.PleaseSelectWellAlgorithm : 'Please Select Well Algorithm' }]}>
								<Select Item
									name="wellalgorithmId"
									mode="multiple"
									showSearch
									placeholder={langdata && langdata.PleaseSelectWellAlgorithm ? langdata.PleaseSelectWellAlgorithm : 'Please Select Well Algorithm' }
									optionFilterProp="children"
									filterOption={filterOption}
									options={algoritham}
									onChange={(value) => addImageconfigFormik.setFieldValue('wellalgorithmId', value)}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name='algtag' >
								<Tag name='algtag' style={{
									maxWidth: '100%',
									whiteSpace: 'normal',
									wordBreak: 'break-word',
									lineHeight: '1.9'
								}} color="blue">{langdata && langdata.Filtertypes ? langdata.Filtertypes : 'Filter types' } {'['}{addImageconfigFormik.values && addImageconfigFormik.values.wellalgorithmId &&<Space wrap>
										{addImageconfigFormik.values.wellalgorithmId.map(item => {
											const alg = algoritham.find(a => a.value === item);
											return (
												<>
													{alg?.label}
												</>
											);
										})}
									</Space>}{']'} </Tag>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="datagenerationtypeId" label={ langdata&&langdata.DataGenerationType?langdata.DataGenerationType:'Data Generation Type'} rules={[{ required: false, message: langdata && langdata.PleaseSelectDataGenerationType ? langdata.PleaseSelectDataGenerationType :'Please Select Data Generation Type'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="datagenerationtypeId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.PleaseSelectDataGenerationType ? langdata.PleaseSelectDataGenerationType :'Please Select Data Generation Type'}
									optionFilterProp="children"	
									onChange={(value) => addImageconfigFormik.setFieldValue('datagenerationtypeId', value)}
									options={datagenop}
														
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="timeTolerance" label={langdata&&langdata.timeTolerance?langdata.timeTolerance:'Time Tolerance'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterTimeTolerance?langdata.PleaseEnterTimeTolerance:'Please the  enter Time Tolerance' }]} >
								<InputNumber 
									name="timeTolerance" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('timeTolerance', value)} 
									placeholder={langdata&&langdata.PleaseEnterTimeTolerance?langdata.PleaseEnterTimeTolerance:'Please the  enter Time Tolerance'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="eventPositionTolerance" label={langdata&&langdata.eventPositionTolerance?langdata.eventPositionTolerance:'Event Position Tolerance'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterEventPositionTolerance?langdata.PleaseEnterEventPositionTolerance:'Please Enter  the event Position Tolerance'}]} >
								<InputNumber 
									name="eventPositionTolerance" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('eventPositionTolerance', value)} 
									placeholder={langdata&&langdata.PleaseEnterEventPositionTolerance?langdata.PleaseEnterEventPositionTolerance:'Please Enter  the event Position Tolerance'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="eventConfidenceThreshold" label={langdata&&langdata.eventConfidenceThreshold?langdata.eventConfidenceThreshold:'Event Confidence Threshold'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterEventConfidenceThreshold?langdata.PleaseEnterEventConfidenceThreshold:'Please enter the  event confidence threshold' }]} >
								<InputNumber 
									name="eventConfidenceThreshold" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('eventConfidenceThreshold', value)} 
									placeholder={langdata&&langdata.PleaseEnterEventConfidenceThreshold?langdata.PleaseEnterEventConfidenceThreshold:'Please enter the  event confidence threshold'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="eventWidthThreshold" label={langdata&&langdata.eventWidthThreshold?langdata.eventWidthThreshold:'Event Width Threshold'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterEventWidthThreshold?langdata.PleaseEnterEventWidthThreshold:'Please Enter Event Width Threshold'}]} >
								<InputNumber 
									name="eventWidthThreshold" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('eventWidthThreshold', value)} 
									placeholder={langdata&&langdata.PleaseEnterEventWidthThreshold?langdata.PleaseEnterEventWidthThreshold:'Please Enter Event Width Threshold'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="durationThreshold" label={langdata&&langdata.durationThreshold?langdata.durationThreshold:'Duration Threshold'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterDurationThreshold?langdata.PleaseEnterDurationThreshold:'Please enter  the duration Threshold' }]} >
								<InputNumber 
									name="durationThreshold" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('durationThreshold', value)} 
									placeholder={langdata&&langdata.PleaseEnterDurationThreshold?langdata.PleaseEnterDurationThreshold:'Please enter  the duration Threshold'} />
							</Form.Item>
						</Col>
					</Row>
					
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="modelclassificationId" label={ langdata&&langdata.ModelClassification?langdata.ModelClassification:'Model Classification'} rules={[{ required: true, message: langdata && langdata.PleaseSelectModelclass ? langdata.PleaseSelectModelclass :'Please Select Model class'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="modelclassificationId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.PleaseSelectModelClass ? langdata.PleaseSelectModelClass :'Please Select model class'}
									optionFilterProp="children"	
									onChange={(value) => addImageconfigFormik.setFieldValue('modelclassificationId', value)}
									options={modelclassificationop}
														
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="modeltypeId" label={ langdata&&langdata.ModelType?langdata.ModelType:'Model Type'} rules={[{ required: true, message: langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="modeltypeId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type'}
									optionFilterProp="children"	
									onChange={(value) => addImageconfigFormik.setFieldValue('modeltypeId', value)}
									options={modeltypeop}
														
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="confidenceThreshold" label={langdata&&langdata.ConfidenceThreshold?langdata.ConfidenceThreshold:'Confidence Threshold'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please enter  the confidence Threshold' }]} >
								<InputNumber 
									name="confidenceThreshold" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('confidenceThreshold', value)} 
									placeholder={langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please enter  the confidence Threshold'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="targetHeight" label={langdata&&langdata.targetHeight?langdata.targetHeight:'Target Height'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterTargetHeight?langdata.PleaseEnterTargetHeight:'Please Enter Target Height'}]} >
								<InputNumber 
									name="targetHeight" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('targetHeight', value)} 
									placeholder={langdata&&langdata.PleaseEnterTargetHeight?langdata.PleaseEnterTargetHeight:'Please Enter Target Height'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="targetWidth" label={langdata&&langdata.targetWidth?langdata.targetWidth:'Target Width'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterTargetWidth?langdata.PleaseEnterTargetWidth:'Please Enter the Target Width' }]} >
								<InputNumber 
									name="targetWidth" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									onChange={(value) => addImageconfigFormik.setFieldValue('targetWidth', value)} 
									placeholder={langdata&&langdata.PleaseEnterTargetWidth?langdata.PleaseEnterTargetWidth:'Please Enter the Target Width'} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
			{/* Add Image config Ends */}

			{/* Edit Image config Starts */}
			<Modal
				
				title={ langdata&&langdata.EditEventValidator?langdata.EditEventValidator:'Edit EventValidator'}
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={ShowEditImageConfigModal}
				onOk={{closeEditImageConfigModal}}
				onCancel={closeEditImageConfigModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeEditImageConfigModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						<Button type="primary" onClick={updateImageConfigFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> 
					</Space>
				]}
				width={800}
			>

				<Form layout="vertical" onSubmit={updateImageConfigFormik.handleSubmit} form={form} onChange={handleupdateFormValuesChange} >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]}>
								<Input 
									name="name" onChange={updateImageConfigFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'}
									defaultValue={updateImageConfigFormik.values.name} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
								<Select Item
									name="PIDS"
									style={{ width: '100%'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
									optionFilterProp="children"
									onSelect={(value)=>{handleupdateFormValuesChange({'PIDS': value});}}         	
									// value={reportFilter.pidsinfoId}
									defaultValue={updateImageConfigFormik.values.pidsinfoId}
									value={reportFilter.pidsinfoId}
									options={pids}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="channelinfoId" label={ langdata&&langdata.channelName?langdata.channelName:'channel Name'} rules={[{ message: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="channelinfoId"
									showSearch
									filterOption={filterOption}
									disabled={channels.length > 1 || reportFilter.pidsinfoId ? false :true}
									placeholder={langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}
									optionFilterProp="children"
									defaultValue={updateImageConfigFormik.values.channelinfoId} 
									// value={reportFilter.channelId}
									
									
									// onSelect={handleSetChannel}
									onSelect={(value)=>{handleupdateFormValuesChange({'channelinfoId': value});}}  
									options={channels}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="batchSize" label={langdata&&langdata.batchSize?langdata.batchSize:'Batch Size'} rules={[{ message: langdata&&langdata.PleaseEnterBatchSize?langdata.PleaseEnterBatchSize:'Please Enter Batch size'}]} >
								<InputNumber 
									name="batchSize" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									defaultValue={updateImageConfigFormik.values.batchSize} 
									onChange={(value) => updateImageConfigFormik.setFieldValue('batchSize', value)} 
									placeholder={langdata&&langdata.PleaseEnterBatchSize?langdata.PleaseEnterBatchSize:'Please Enter Batch size'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.eventTypes ? langdata.eventTypes : 'Event Types'} name="eventTypes" rules={[{message: langdata && langdata.PleaseEnterEventTypes ? langdata.PleaseEnterEventTypes : 'Please select the  Event Types' }]}>
								<Select Item
									name="eventTypes"
									mode="multiple"
									showSearch
									defaultValue={updateImageConfigFormik.values.eventTypes} 
									placeholder={langdata && langdata.PleaseEnterEventTypes ? langdata.PleaseEnterEventTypes : 'Please select the  Event Types'}
									optionFilterProp="children"
									filterOption={filterOption}
									options={allevents}
									onChange={(value) => updateImageConfigFormik.setFieldValue('eventTypes', value)}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Tag style={{
								maxWidth: '100%',
								whiteSpace: 'normal',
								wordBreak: 'break-word',
								lineHeight: '1.9'
							}} color="blue">{langdata && langdata.PredictionEventType ? langdata.PredictionEventType : 'Prediction Event Type in ' } {'['}{updateImageConfigFormik.values && updateImageConfigFormik.values.eventTypes && updateImageConfigFormik.values.eventTypes.toString()}{']'} </Tag>
						</Col>
						<Space>&nbsp;</Space>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.modelPath ? langdata.modelPath : 'Model Path'} rules={[{ message: langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter Model Path' }]} >
								<Input name="modelPath" onChange={updateImageConfigFormik.handleChange} 
									defaultValue={updateImageConfigFormik.values.modelPath} 
									placeholder={langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter Model Path'} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.curlPath ? langdata.curlPath : 'Curl Path'} rules={[{ message: langdata && langdata.PleaseEnterCurlPath ? langdata.PleaseEnterCurlPath : 'Please the enter Curl Path' }]} >
								<Input 
									name="curlPath" 
									onChange={updateImageConfigFormik.handleChange} 
									defaultValue={updateImageConfigFormik.values.curlPath}
									placeholder={langdata && langdata.PleaseEnterCurlPath ? langdata.PleaseEnterCurlPath : 'Please the enter curl Path'} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.PickleFilePath ? langdata.PickleFilePath : 'Pickle File Path'} rules={[{ message: langdata && langdata.PleaseEnterPickleFilePath ? langdata.PleaseEnterPickleFilePath : 'Please Enter Pickle File Path' }]} >
								<Input 
									name="pickleFilePath" 
									onChange={updateImageConfigFormik.handleChange} 
									defaultValue={updateImageConfigFormik.values.pickleFilePath}
									placeholder={langdata && langdata.PleaseEnterPickleFilePath ? langdata.PleaseEnterPickleFilePath : 'Please Enter Pickle File Path'} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Filters ? langdata.Filters : 'Filters'} name="wellalgorithmId" rules={[{message : langdata && langdata.PleaseSelectWellAlgorithm ? langdata.PleaseSelectWellAlgorithm : 'Please Select Well Algorithm' }]}>
								<Select Item
									name="wellalgorithmId"
									mode="multiple"
									showSearch
									// placeholder={langdata && langdata.PleaseSelectWellAlgorithm ? langdata.PleaseSelectWellAlgorithm : 'Please Select Well Algorithm' }
									optionFilterProp="children"
									filterOption={filterOption}
									options={algoritham}
									defaultValue={updateImageConfigFormik.values.wellalgorithmId}
									onChange={(value) => updateImageConfigFormik.setFieldValue('wellalgorithmId', value)}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name='algtag' >
								<Tag name='algtag' style={{
									maxWidth: '100%',
									whiteSpace: 'normal',
									wordBreak: 'break-word',
									lineHeight: '1.9'
								}} color="blue">{langdata && langdata.Filtertypes ? langdata.Filtertypes : 'Filter types' } {'['}{updateImageConfigFormik.values && updateImageConfigFormik.values.wellalgorithmId &&<Space wrap>
										{updateImageConfigFormik.values.wellalgorithmId.map(item => {
											const alg = algoritham.find(a => a.value === item);
											return (
												<>
													{alg?.label}
												</>
											);
										})}
									</Space>}{']'} </Tag>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="datagenerationtypeId" label={ langdata&&langdata.DataGenerationType?langdata.DataGenerationType:'Data Generation Type'} rules={[{ required: false, message: langdata && langdata.PleaseSelectDataGenerationType ? langdata.PleaseSelectDataGenerationType :'Please Select Data Generation Type'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="datagenerationtypeId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.PleaseSelectDataGenerationType ? langdata.PleaseSelectDataGenerationType :'Please Select Data Generation Type'}
									optionFilterProp="children"	
									defaultValue={updateImageConfigFormik.values.datagenerationtypeId}
									onChange={(value) => updateImageConfigFormik.setFieldValue('datagenerationtypeId', value)}
									options={datagenop}
														
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="timeTolerance" label={langdata&&langdata.timeTolerance?langdata.timeTolerance:'Time Tolerance'} rules={[{ message: langdata&&langdata.PleaseEnterTimeTolerance?langdata.PleaseEnterTimeTolerance:'Please the  enter Time Tolerance' }]} >
								<InputNumber 
									name="timeTolerance" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									defaultValue={updateImageConfigFormik.values.timeTolerance} 
									onChange={(value) => updateImageConfigFormik.setFieldValue('timeTolerance', value)} 
									placeholder={langdata&&langdata.PleaseEnterTimeTolerance?langdata.PleaseEnterTimeTolerance:'Please the  enter Time Tolerance'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="eventPositionTolerance" label={langdata&&langdata.eventPositionTolerance?langdata.eventPositionTolerance:'Event Position Tolerance'} rules={[{  message: langdata&&langdata.PleaseEnterEventPositionTolerance?langdata.PleaseEnterEventPositionTolerance:'Please Enter  the event Position Tolerance' }]} >
								<InputNumber 
									name="eventPositionTolerance" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									onChange={(value) => updateImageConfigFormik.setFieldValue('eventPositionTolerance', value)} 
									defaultValue={updateImageConfigFormik.values.eventPositionTolerance} 
									placeholder={langdata&&langdata.PleaseEnterEventPositionTolerance?langdata.PleaseEnterEventPositionTolerance:'Please Enter  the event Position Tolerance'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="eventConfidenceThreshold" label={langdata&&langdata.eventConfidenceThreshold?langdata.eventConfidenceThreshold:'Event Confidence Threshold'} rules={[{  message: langdata&&langdata.PleaseEnterEventConfidenceThreshold?langdata.PleaseEnterEventConfidenceThreshold:'Please enter the  event confidence threshold'}]} >
								<InputNumber 
									name="eventConfidenceThreshold" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => updateImageConfigFormik.setFieldValue('eventConfidenceThreshold', value)} 
									defaultValue={updateImageConfigFormik.values.eventConfidenceThreshold} 
									placeholder={langdata&&langdata.PleaseEnterEventConfidenceThreshold?langdata.PleaseEnterEventConfidenceThreshold:'Please enter the  event confidence threshold'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="eventWidthThreshold" label={langdata&&langdata.eventWidthThreshold?langdata.eventWidthThreshold:'Event Width Threshold'} rules={[{message: langdata&&langdata.PleaseEnterEventWidthThreshold?langdata.PleaseEnterEventWidthThreshold:'Please Enter Event Width Threshold'}]} >
								<InputNumber 
									name="eventWidthThreshold" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => updateImageConfigFormik.setFieldValue('eventWidthThreshold', value)} 
									defaultValue={updateImageConfigFormik.values.eventWidthThreshold} 
									placeholder={langdata&&langdata.PleaseEnterEventWidthThreshold?langdata.PleaseEnterEventWidthThreshold:'Please Enter Event Width Threshold'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="durationThreshold" label={langdata&&langdata.durationThreshold?langdata.durationThreshold:'Duration Threshold'} rules={[{message: langdata&&langdata.PleaseEnterDurationThreshold?langdata.PleaseEnterDurationThreshold:'Please enter  the duration Threshold'}]} >
								<InputNumber 
									name="durationThreshold" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => updateImageConfigFormik.setFieldValue('durationThreshold', value)} 
									defaultValue={updateImageConfigFormik.values.durationThreshold} 
									placeholder={langdata&&langdata.PleaseEnterDurationThreshold?langdata.PleaseEnterDurationThreshold:'Please enter  the duration Threshold'} />
							</Form.Item>
						</Col>
					</Row>
					
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="modelclassificationId" label={ langdata&&langdata.ModelClassification?langdata.ModelClassification:'Model Classification'} rules={[{ message: langdata && langdata.PleaseSelectModelclass ? langdata.PleaseSelectModelclass :'Please Select Model class'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="modelclassificationId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.PleaseSelectModelClass ? langdata.PleaseSelectModelClass :'Please Select model class'}
									optionFilterProp="children"	
									defaultValue ={updateImageConfigFormik?.values?.modelclassificationId}
									onChange={(value) => updateImageConfigFormik.setFieldValue('modelclassificationId', value)}
									options={modelclassificationop}
														
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="modeltypeId" label={ langdata&&langdata.ModelType?langdata.ModelType:'Model Type'} rules={[{  message: langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="modeltypeId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type'}
									optionFilterProp="children"	
									defaultValue={updateImageConfigFormik.values.modeltypeId}
									onChange={(value) => updateImageConfigFormik.setFieldValue('modeltypeId', value)}
									options={modeltypeop}
														
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="confidenceThreshold" label={langdata&&langdata.ConfidenceThreshold?langdata.ConfidenceThreshold:'Confidence Threshold'} rules={[{ message: langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please enter  the confidence Threshold' }]} >
								<InputNumber 
									name="confidenceThreshold" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									defaultValue={updateImageConfigFormik.values.confidenceThreshold}
									onChange={(value) => updateImageConfigFormik.setFieldValue('confidenceThreshold', value)} 
									placeholder={langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please enter  the confidence Threshold'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="targetHeight" label={langdata&&langdata.targetHeight?langdata.targetHeight:'Target Height'} rules={[{  message: langdata&&langdata.PleaseEnterTargetHeight?langdata.PleaseEnterTargetHeight:'Please Enter Target Height' }]} >
								<InputNumber 
									name="targetHeight" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									onChange={(value) => updateImageConfigFormik.setFieldValue('targetHeight', value)} 
									defaultValue={updateImageConfigFormik.values.targetHeight} 
									placeholder={langdata&&langdata.PleaseEnterTargetHeight?langdata.PleaseEnterTargetHeight:'Please Enter Target Height'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="targetWidth" label={langdata&&langdata.targetWidth?langdata.targetWidth:'Target Width'} rules={[{ message: langdata&&langdata.PleaseEnterTargetWidth?langdata.PleaseEnterTargetWidth:'Please Enter the Target Width'}]} >
								<InputNumber 
									name="targetWidth" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={1}
									min={0}
									onChange={(value) => updateImageConfigFormik.setFieldValue('targetWidth', value)} 
									defaultValue={updateImageConfigFormik.values.targetWidth} 
									placeholder={langdata&&langdata.PleaseEnterTargetWidth?langdata.PleaseEnterTargetWidth:'Please Enter the Target Width'} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
			{/* Edit Image config  Ends */}

			{/* Delete  Image config  Starts */}
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteImageConfigModal} onOk={deleteImageConfigStatus} onCancel={closeDeleteImageConfigModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.ConfirmDeleteEventValidator?langdata.ConfirmDeleteEventValidator:'Are you sure you want to delete this event validator?' }</Col>
				</Row>
			</Modal>
			{/* Delete  Image config  Ends */}
		</> 
	);
}